import type { FC } from 'react';
import {
  FilterProvider,
  LocalCashTables,
  PaginationProvider,
  SearchProvider,
  SortProvider,
} from 'dash-ui';

import PropertiesDataProvider from 'common/contexts/PropertiesData/PropertiesDataProvider';

import CMSPropertiesTable from './components/CMSPropertiesTable/CMSPropertiesTable';
import type { PropertiesProps } from './Properties.interfaces';

const Properties: FC<PropertiesProps> = ({ tableProps, filter }) => {
  return (
    <PaginationProvider storageTableName={LocalCashTables.PROPERTIES}>
      <SortProvider>
        <SearchProvider>
          <FilterProvider>
            <PropertiesDataProvider filter={filter}>
              <CMSPropertiesTable {...tableProps} />
            </PropertiesDataProvider>
          </FilterProvider>
        </SearchProvider>
      </SortProvider>
    </PaginationProvider>
  );
};

export default Properties;
